/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightDrawingsQueryResponse, TrimbleItemsControllerListProjectSightDrawingsQueryParams } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightDrawings";

function getTrimbleItemsControllerListProjectSightDrawingsUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble/projectsight/drawings` as const }  
  return res
}

/**
 * @summary List a ProjectSight project's current drawings, or one drawing set's drawings
 * {@link /api/v1/trimble/projectsight/drawings}
 */
export async function trimbleItemsControllerListProjectSightDrawings(params: TrimbleItemsControllerListProjectSightDrawingsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerListProjectSightDrawingsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTrimbleItemsControllerListProjectSightDrawingsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}